import queryProjects from './modules/store'

export const modules = {
  queryProjects
}



// WEBPACK FOOTER //
// ./src/store/QueryProjects/index.js